
import {
	DBxEvent,
    StringFilter,
    DataQueryFilter
} from "cartovista";
import ClusterAlgorithmExtend from "cartovistaExtend/layers/ClusterAlgorithmExtend";
import {queryLayer, queryStore} from "cartovistaExtend/utils/ServerRequests";
import {createFeatures, createDataRows, createLayer, createThemeSetElement, _loadEsriLayersData, _loadCartovistaLayersData } from "cartovistaExtend/utils/CvUtils";

export function loadData() {
    $("#Loader_container").css("display", "block");
        return Promise.all([_loadStoresData(C.DATASTORES), _loadLayersData(_.filter(C.LAYERS, {LOADING_MODE : "INITIAL"})), _loadEsriLayersData(_.filter(C.LAYERS, {LOADING_MODE : "ESRI"})), _loadCartovistaLayersData(_.filter(C.LAYERS, {LOADING_MODE : "CARTOVISTA"}))]).then(function(responses) {
             return responses;
        }).then(function(responses) {
            window.cartovista.dispatchEvent(new DBxEvent("ServerDataInitialized"));
            window.cartovista.addOneTimeEventListener("AuthSession_UserLoggedOut", _onUserLoggedOut);
            filterLayers();
            changeLayerName();
            $("#Loader_container").css("display", "none");
        })
        .catch(function(error){
            window.cartovista.addOneTimeEventListener("AuthSession_UserLoggedIn", _onUserLoggedIn);
            window.cartovista.dispatchEvent(new DBxEvent("ServerDataInitialized"));
            $("#Loader_container").css("display", "none");
       });
};

    function _loadLayersData(layerConfigs) {
          return Promise.all(_.map(layerConfigs, function(layerConfig, idx) {
              return queryLayer(layerConfig, typeof layerConfig.QUERY_EXPRESSION != "undefined" ? layerConfig.QUERY_EXPRESSION : null)
                  .then(function(response) {
                    switch (layerConfig.LAYER_ID) {
                        case C.LAYERS.DRAWING_LAYER.ANNOTATIONS.LAYER_ID:
                        case C.LAYERS.DRAWING_LAYER.LINES.LAYER_ID:
                            var drawingLayerConfig = _.cloneDeep(C.LAYERS.DRAWING_LAYER);
                            drawingLayerConfig.LAYER_TYPE = layerConfig.LAYER_TYPE;
                            drawingLayerConfig.STYLES = layerConfig.STYLES;
                            drawingLayerConfig.FEATURES_PROPERTIES = layerConfig.FEATURES_PROPERTIES;
                            return _createFeaturesAndDataRows(drawingLayerConfig, response);
                        case C.LAYERS.GEO07E16_POINTS_0_4_ANS_SPES.LAYER_ID:
                            return _createPoints04AnsFeaturesDataByLayer(response);
                        default:
                            return _createFeaturesAndDataRows(layerConfig, response);
                    };
                });
           }));
     };

     function _loadStoresData(storeConfigs) {
        return Promise.all(_.map(storeConfigs, function(storeConfig) {
            return queryStore(storeConfig, typeof storeConfig.QUERY_EXPRESSION != "undefined" ? storeConfig.QUERY_EXPRESSION : null)
                .then(function(response) {
                    switch (storeConfig.ID) {
                       case "sectorsDataStore":
                            _storeSectorsData(C.DATASTORES.SECTORS_DATA, response);
                           break;
                        default:
                            throw new Error("ServerDataHandlers._loadStoresData() - storeConfig.ID : " + storeConfig.ID + " is invalid.");
                    }
                });
        })).then(function(responses) {
            window.cartovista.dispatchEvent(new DBxEvent("StoresDataLoaded"));
        });
    };
    var activeThemeSet = null;
    function _onUserLoggedIn() {
        $("#Loader_container").css("display", "block");
        Promise.all([_loadStoresData(_.filter(C.DATASTORES, "TOKEN_REQUIRED")), _loadLayersData(_.filter(C.LAYERS, "TOKEN_REQUIRED"))]).then(function(responses) {
                    return responses;
            }).then(function(responses) {
                window.cartovista.dispatchEvent(new DBxEvent("ServerDataInitialized"));
            window.cartovista.addOneTimeEventListener("AuthSession_UserLoggedOut", _onUserLoggedOut);
            filterLayers();
            changeLayerName();
            $("#Loader_container").css("display", "none");
            window.cartovista.dispatchEvent(new DBxEvent("ReloadDataTool_ReloadCompleted"));
            if(window.cartovista.externalInterface.map.activeThemeSet == null) window.cartovista.externalInterface.map.activeThemeSet = activeThemeSet;
        });
        //log user event on piwik
        try {
            dataLayer.push({'event':'onUserLogin', 'logged_user': window.sessionStorage.getItem("username") + " - éditeur:" + JSON.parse(window.sessionStorage.getItem(window.sessionStorage.getItem("username"))).EDITION_ALLOWED});
        } catch(error) {
            //piwik blocked by an add blocker
            window.ClientErrorsLogger.logPiwikError(error);
        }
     }

     function _onUserLoggedOut() {
        window.cartovista.dispatchEvent(new DBxEvent("ReloadDataTool_ReloadStarted"));
        activeThemeSet = window.cartovista.externalInterface.map.activeThemeSet;
        window.cartovista.externalInterface.map.activeThemeSet = null;
        _.forEach(_.filter(C.LAYERS, (layerConfig) => layerConfig.TOKEN_REQUIRED || layerConfig.LAYER_ID == "DRAWING_LAYER"), (layerConfig) => _deleteFeaturesAndDataRows(layerConfig));
        _.forEach(_.filter(C.DATASTORES, "TOKEN_REQUIRED"), (storeConfig) => _deleteStoreItems(storeConfig));
        window.cartovista.addOneTimeEventListener("AuthSession_UserLoggedIn", _onUserLoggedIn);
     }

     function _deleteFeaturesAndDataRows(layerConfig) {
        var map = window.cartovista.getMap(C.MAP.ID);
        var layer = map.getLayer(layerConfig.LAYER_ID);
        if(layer){
            layer.removeAllFeatures();
        }
     }

     function _deleteStoreItems(storeConfig) {
        window[storeConfig.ID].deleteItems();
     }

    function _createFeaturesAndDataRows(layerConfig, layerData) {
        return new Promise(function(resolve, reject) {
            if (!window.cartovista.getMap(C.MAP.ID) || !window.cartovista.getMap(C.MAP.ID).getLayer(layerConfig.LAYER_ID)) {
                window.cartovista.addOneTimeEventListener(layerConfig.LAYER_ID + "_layerCreated", resolve.bind(layerData));
            } else {
                resolve(layerData);
            }
        }).then(function() {
          if(layerData.features == 0 && layerConfig.LAYER_ID != "DRAWING_LAYER"){
            var map = window.cartovista.getMap(C.MAP.ID),
                layer = map.getLayer(layerConfig.LAYER_ID);
            layer.isVisibleInLayerControl = false;
            layer.isVisibleInLegend = false;
            map.removeLayer(layer);
            map.addLayerAt(layer, layerConfig.INDEX);
          } else{
            var map = window.cartovista.getMap(C.MAP.ID),
                layer = map.getLayer(layerConfig.LAYER_ID),
                features = createFeatures(layerConfig, layerData.features),
                dataTable = layer.getDataTable(layerConfig.DATATABLE_ID),
                dataRows = createDataRows(layerConfig, layerData.features, _.map(features, "id"));
            layer.addFeatures(features);
            dataTable.addDataRows(dataRows);
            if (layerConfig.LAYER_PROPERTIES.CLUSTERING_ENABLED) {
                layer.vectorSource.clusteringAlgorithm = new ClusterAlgorithmExtend(map, layerConfig.LAYER_PROPERTIES.CLUSTER_SIZE, layer, dataTable.getDataColumns(layerConfig.LAYER_PROPERTIES.CLUSTER_GROUP_BY_DATACOLUMN)[0]);
            }
            window.cartovista.dispatchEvent(new DBxEvent(layerConfig.LAYER_ID + "_featuresCreated", {"layer": layer, "dataTable": dataTable}));
        }
        return layerData;
        });
    };

    export function createLayers() {
        var map = window.cartovista.getMap(C.MAP.ID);
        _.forEach(_.filter(C.LAYERS, function(layerConfig) { return layerConfig.LAYER_ID != "GEO07E13_LINES_SPES" && layerConfig.LAYER_ID != "GEO07E14_ANNOTATIONS_SPES"}), function(layerConfig) {
            var layer = createLayer(layerConfig),
                index = typeof layerConfig.INDEX != "undefined" ? layerConfig.INDEX : map.layers.length;
            map.addLayerAt(layer, index);
            window.cartovista.dispatchEvent(new DBxEvent(layerConfig.LAYER_ID + "_layerCreated", {"layer": layer}));
        });
    };

    function _storeSectorsData(sectorsDataStoreConfig, sectorsData) {
        return new Promise(function(resolve, reject) {
            if (!window.cartovista.getMap(C.MAP.ID)) {
                window.cartovista.addEventListener(cartovista.EVENTS.MAP_LOADED + "_" + C.MAP.ID, resolve);
            } else {
                resolve();
            }
        }).then(function() {
            return _.forEach(sectorsData.features, function(sectorData) {
                return window.sectorsDataStore.storeSectorData(sectorData.attributes);
            });
        });
    }

    export function createThemeSetsElements() {
        var map = window.cartovista.getMap(C.MAP.ID),
            themeSetsElements = _.map(C.THEMESETS_ELEMENTS, function(themeSetElementConfig){
                if (C.APP_TOOLS.AUTH_SESSION.USER.SELECTED_SCENARIO) {
                    themeSetElementConfig.LAYERS_SETTINGS = [];
                    if (C.APP_TOOLS.AUTH_SESSION.USER.APPROVED && themeSetElementConfig.ID == C.APP_TOOLS.AUTH_SESSION.USER.SELECTED_SCENARIO) {
                        themeSetElementConfig.TITLE += " - Approuvé";
                    }
                }
            return createThemeSetElement(themeSetElementConfig);
        });
        map.addThemeSetElement(themeSetsElements);
    };

    function _createPoints04AnsFeaturesDataByLayer(response) {
        var layerConfigs = [C.LAYERS.GEO07E16_POINTS_0_AN_SPES, C.LAYERS.GEO07E16_POINTS_1_AN_SPES, C.LAYERS.GEO07E16_POINTS_2_ANS_SPES, C.LAYERS.GEO07E16_POINTS_3_ANS_SPES, C.LAYERS.GEO07E16_POINTS_4_ANS_SPES, C.LAYERS.GEO07E16_POINTS_0_4_ANS_SPES];
        var result = _.reduce(layerConfigs, function(result, layerConfig) {
            result[layerConfig.LAYER_ID] = {"features": []};
            return result;
        }, {});
        var featuresDataCollection = _.reduce(response.features, function(result, featureData) {
            if (featureData.attributes["POP_0"] !== 0) {
                result["GEO07E16_POINTS_0_AN_SPES"].features.push(featureData);
            }
            if (featureData.attributes["POP_1"] !== 0) {
                result["GEO07E16_POINTS_1_AN_SPES"].features.push(featureData);
            }
            if (featureData.attributes["POP_2"] !== 0) {
                result["GEO07E16_POINTS_2_ANS_SPES"].features.push(featureData);
            }
            if (featureData.attributes["POP_3"] != 0) {
                result["GEO07E16_POINTS_3_ANS_SPES"].features.push(featureData);
            }
            if (featureData.attributes["POP_4"] != 0) {
                result["GEO07E16_POINTS_4_ANS_SPES"].features.push(featureData);
            }
            result["GEO07E16_POINTS_0_4_ANS_SPES"].features.push(featureData);
            return result;
        }, result);
        return Promise.all(_.map(layerConfigs, function(layerConfig) {
            return _createFeaturesAndDataRows(layerConfig, featuresDataCollection[layerConfig.LAYER_ID]);
        }));
    };

    function filterLayers(){
        var map = window.cartovista.getMap(C.MAP.ID);
        var configs = {
            CS_SPES: {DATATABLE_ID: "t_CS_SPES", DATACOLUMN_ID: "c_CD_CS"},
            MUNCP_SPES: {DATATABLE_ID: "t_MUNCP_SPES", DATACOLUMN_ID: "c_CD_CS"},
            AD_SPES: {DATATABLE_ID: "t_AD_SPES", DATACOLUMN_ID: "c_CD_CS"},
            CP_SPES: {DATATABLE_ID: "t_CP_SPES", DATACOLUMN_ID: "c_CD_CS"},
            GEO09E32_GDUNO_IMMBL: {DATATABLE_ID: "AttributesDataTable_GEO09E32_GDUNO_IMMBL", DATACOLUMN_ID: "CD_CS"},
        }
        Promise.all(_.map(configs, function(config, layerId){
            return new Promise(function(resolve, reject) {
                var layer = map.getLayer(layerId);
                var datatable = layer.getDataTable(config.DATATABLE_ID);
                var datacolumn = datatable.getDataColumns(config.DATACOLUMN_ID)[0];
                if(!datacolumn.hasFilters()) {
                    var dataquery = layer.createDataQuery([layer.featureIdDataColumn]);
                    dataquery.setDataQueryFilters([new DataQueryFilter(datacolumn, [new StringFilter("IS_NOT_EQUAL_TO", C.APP_TOOLS.AUTH_SESSION.USER.CD_CS)], "and")]);
                    dataquery.execute(function(result){
                        if(result.linkingIds.length == 0 && layer.id == "GEO09E32_GDUNO_IMMBL"){
                            layer.addOneTimeEventListener(layer.EVENTS.FEATURES_ADDED, function(){ dataquery.execute(function(result){ resolve({result: result, layer: layer, datatable: datatable}); }); }, this);
                        } else{
                            resolve({result: result, layer: layer, datatable: datatable});
                        }
                    });
                }
            });
        })).then(function(responses){
            _.forEach(responses, function(response){
                _removeFeatures(response.layer, response.result.linkingIds);   
                _removeDataRows(response.datatable, response.result.linkingIds);
            });
        });
    }

    function _removeFeatures(layer, linkingIds){
        layer.getSimpleFeatures(linkingIds, function(result) {
            if(result.features.length == 0){
                layer.addOneTimeEventListener(layer.EVENTS.FEATURES_ADDED, _removeFeatures.bind(this, layer, linkingIds));
            } else{
                layer.removeFeatures(result.features);
                if(C.MAP.INITIAL_EXTENT_LAYER == layer.id) _setInitialExtent(layer);
            }
        });
    }

    function _removeDataRows(datatable, linkingIds){
        datatable.removeDataRows(linkingIds);
    }

    function _setInitialExtent(layer) {
        var map = window.cartovista.getMap(C.MAP.ID);
        var mapController = window.cartovista.getMapController(map);
        layer.getFeatures(null, function(result) {
            var extent = result.features[0].extent.clone();
            extent.inflate(extent.width * 0.10, extent.height * 0.10);
            map.initialExtent = extent;
            mapController.resetMapExtent();
        });
    };

    function changeLayerName(){
        const cs = ["759000","769000","881000","882000","883000","884000","885000","886000","887000","888000","889000"]
        if(_.includes(cs, C.APP_TOOLS.AUTH_SESSION.USER.CD_CS)){
            var map = window.cartovista.getMap(C.MAP.ID);
            var layer = map.getLayer("CS_SPES");
            layer.name = "Commission scolaire";
        }
    }